import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { END_SESSION } from "@Broker/@Modules/main/store/account/account-actions";
import Amplitude from "@Shared/@Utils/amplitude";
import { LOAD_ACCOUNT_PLAN_DETAILS } from "../../store/account-plan-actions";
import { PAYMENT_DETAILS, IS_CURRENT_USER_PAYER } from "../../store/account-plan-getters";
import AccountPlanLoader from "./account-plan-loader.vue";
import { CURRENT_ACCOUNT_PLAN, CURRENT_USER_DETAILS, SHOULD_SHOW_PAYMENT_FAILED_BANNER } from "@Broker/@Modules/main/store/account/account-getters";
import NavigationBar from "@Shared/components/general/navigation-bar.vue";
import CurrentAccountContainer from "./current-account-container.vue";
import SubscriptionsContainer from "./subscriptions-container.vue";
import InvoicesContainer from "./invoices-container.vue";
import PaymentMethods from "./payment-methods.vue";
import PageHeader from "@Shared/components/general/page-header";
import { LOAD_AGENTS } from "@Broker/@Modules/agents/store/agent-actions";
import { ACCOUNT_PLAN_TABS } from "@Broker/@Utils/enum";
import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountPlanContainer",
  title() {
    return this.$t("sidebar.sections.accountPlan");
  },
  components: {
    PaymentMethods,
    AccountPlanLoader,
    NavigationBar,
    CurrentAccountContainer,
    PageHeader,
    SubscriptionsContainer,
    InvoicesContainer,
    FixedBanner
  },
  props: {
    paymentFailure: {
      type: String,
      default: ""
    },
    internal: {
      type: Boolean,
      default: false
    },
    tab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      currentTab: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountPlanStore", [PAYMENT_DETAILS, IS_CURRENT_USER_PAYER])), mapGetters("AccountStore", [CURRENT_USER_DETAILS, CURRENT_ACCOUNT_PLAN, SHOULD_SHOW_PAYMENT_FAILED_BANNER])), {}, {
    pageTitle() {
      if (this.paymentFailure === "trial-ended") return this.$t("account.accountPlan.freeTrialExpiredMessage");
      if (this.paymentFailure === "payment-failed") {
        return this.$t("account.accountPlan.paymentFailedMessage");
      }
      return this.CURRENT_ACCOUNT_PLAN === "professional" ? this.$t("account.accountPlan.yourAccountPlan") : this.$t("account.accountPlan.upgradePlan");
    },
    pageSubtitle() {
      if (this.paymentFailure) return this.$t("account.accountPlan.nothingWillBeLostMessage");
      return "";
    },
    tabs() {
      return ACCOUNT_PLAN_TABS();
    },
    currentTabComponent() {
      var _this$tabs$this$curre;
      return this.currentTab ? (_this$tabs$this$curre = this.tabs[this.currentTab]) == null ? void 0 : _this$tabs$this$curre.component : null;
    },
    paymentFailureMessage() {
      const subMessage = this.IS_CURRENT_USER_PAYER ? this.$t("account.accountPlan.planModals.paymentFailed.checkYourInvoices") : this.$t("account.accountPlan.planModals.paymentFailed.contactYourPayer");
      return `${this.$t("account.accountPlan.planModals.paymentFailed.title")}. ${subMessage}`;
    }
  }),
  beforeMount() {
    this.load();
    Amplitude.logEvent("Account Plan - visited");
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [END_SESSION])), mapActions("AccountPlanStore", [LOAD_ACCOUNT_PLAN_DETAILS])), mapActions("AgentStore", [LOAD_AGENTS])), {}, {
    async load() {
      this.setInitialCurrentTab();
      if (!this.internal) {
        this.loading = true;
        const promises = [this.LOAD_AGENTS(), this.LOAD_ACCOUNT_PLAN_DETAILS()];
        await _Promise.all(promises);
        this.loading = false;
      }
    },
    closeSessionAndLogin() {
      this.END_SESSION();
    },
    setInitialCurrentTab() {
      this.currentTab = this.tab || _Object$keys(this.tabs)[0];
    },
    handleTabChange(tab) {
      Amplitude.logEvent(`Account Plan - ${tab} Visited`, {
        currentTab: tab
      });
      this.currentTab = tab;
    }
  })
});